export default __webpack_public_path__ + "static/media/white-go-4.8c4cbb7f.svg";